'use client'

import type { Locale } from '@/lib/i18n/locales'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@mentora/ui-components'
import { Globe } from 'lucide-react'
import { useLocale, useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import { useTransition } from 'react'
import { setLanguageAction } from '@/app/actions/i18n'
import { isLocale, LOCALE_LABELS, SUPPORTED_LOCALES } from '@/lib/i18n/locales'

export function LanguageSwitcher() {
  const router = useRouter()
  const currentLocale = useLocale()
  const t = useTranslations('languageSwitcher')
  const [isPending, startTransition] = useTransition()

  const active: Locale = isLocale(currentLocale) ? currentLocale : 'pt-br'

  function onSelect(locale: Locale) {
    if (locale === active)
      return
    startTransition(async () => {
      await setLanguageAction(locale)
      router.refresh()
    })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={t('label')}
          title={t('label')}
          disabled={isPending}
          className="inline-flex size-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:opacity-60"
        >
          <Globe className="size-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('label')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SUPPORTED_LOCALES.map(locale => (
          <DropdownMenuCheckboxItem
            key={locale}
            checked={locale === active}
            onCheckedChange={() => onSelect(locale)}
          >
            {LOCALE_LABELS[locale]}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
